import cn from 'clsx'
import s from './styles.module.scss'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { CopyIcon } from '@App/static/icons/SortIcons'
import { Button } from '@App/ui/crypto_exchange/desktop/components/controls/Button'

import {Order, Trade} from "@Redux/slices/trade/trades/types"

import { formatDate, formatTime, useCopyText, useSeeMarket } from '../../model'

export const TradeInfo = ({
  trade,
  type = 'trade',
  onEditTrade,
}: {
  trade: Trade|Order
  onEditTrade?: () => void
  type?: 'order' | 'trade'
}) => {
  const { copyText } = useCopyText()
  const { seeMarket } = useSeeMarket({
    sourceCurrency: trade.market.source,
    targetCurrency: trade.market.target,
  })
  return (
    <div className={s.content}>
      <div className={s.general}>
        <div className={s.id}>
          ID:{trade.front_id} <CopyIcon className={s.icon} onClick={() => copyText(trade.front_id)} />
        </div>
        <div className={s.details}>
          <div className={cn(s.section, s.border)}>
            <div className={s.value}>{formatDate(trade.open_time)}</div>
            <div className={s.subValue}>{formatTime(trade.open_time)}</div>
          </div>
          <div className={s.section}>
            <div className={s.value}>
              {trade.market.source_name}/{trade.market.target_name}
            </div>
            <div className={s.subValue}>
              {trade.market.source_name} to {trade.market.target_name}
            </div>
          </div>
        </div>
        <div className={cn(s.info, s.border)}>
          <div className={s.title}>Triggered by</div>
          <div className={s.value}>User</div>
        </div>
        <div className={s.info}>
          <div className={s.title}>Currency</div>
          <div className={s.value}>{trade.market.target}</div>
        </div>
        <div className={s.actions}>
          <Button valiant="outlined" onClick={seeMarket}>
            See market
          </Button>
          {trade.status === 'open' && (
            <Button valiant="text" onClick={onEditTrade}>
              <> Edit {type}</>
            </Button>
          )}
        </div>
      </div>
      <div className={s.history}>
        <div className={s.item}>
          <div className={s.header}>
            <div className={s.time}>
              {formatDate(trade.open_time)} {formatTime(trade.open_time)}
            </div>
            <div className={s.title}>
              Opened
              <div className={cn(s.quantity, trade.action_type === 'buy' && s.buy)}>
                {trade.action_type === 'buy' ? '+' : '-'}
                {trade.quantity}
              </div>
              {trade.market.source_name}/{trade.market.target_name}
            </div>
          </div>
          <div className={cn(s.info, s.borderTop)}>
            <div className={s.title}>At price</div>
            <div className={s.value}>{getValueWithCurrency(trade.currency, trade.open_rate)}</div>
          </div>
        </div>
        {trade.status === 'closed' && (
          <div className={s.item}>
            <div className={s.header}>
              <div className={s.time}>
                {formatDate(trade.open_time)} {formatTime(trade.open_time)}
              </div>
              <div className={s.title}>
                Closed{' '}
                <div className={cn(s.quantity, trade.action_type !== 'buy' && s.buy)}>
                  {' '}
                  {trade.action_type !== 'buy' ? '+' : '-'}
                  {trade.quantity}
                </div>{' '}
                {trade.market.source_name}/{trade.market.target_name}
              </div>
            </div>
            <div className={cn(s.info, s.borderTop)}>
              <div className={s.title}>At price</div>
              <div className={s.value}>{getValueWithCurrency(trade.currency, trade?.close_rate ?? 0)}</div>
            </div>
            <div className={cn(s.info, s.borderTop, s.border)}>
              <div className={s.title}>Coversion rate</div>
              <div className={s.value}>1</div>
            </div>
            <div className={cn(s.info, s.borderTop)}>
              <div className={s.title}>Total</div>
              <div className={cn(s.value, trade.result < 0 ? s.negative : s.positive)}>
                {getValueWithCurrency(trade.currency, trade?.result ?? 0)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
